// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"196":"46eb7b06","254":"62f0e2d8","633":"52c29ce8","800":"63d7ef42","809":"292dca10","864":"96a59529"}[chunkId] + ".css";
};